<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">创建模板组</div>
    <div class="third-title"><span>模板信息</span></div>
    <div class="order-detail-basic">
      <el-form v-for="(item, i) in sizeGroupMsg.sizeList" :key="item.id" :model="sizeGroupMsg" label-width="100px" ref="formRef">
        <el-form-item :label="$store.state.pms.pageType[item.pageTypeCode] + '模板数量:'">
          <span>{{ item.templates.length }}</span>
        </el-form-item>
        <el-form-item :label="'关联模板性质:'">
          <span>{{ item.spuPageName.templateProperty }}</span>
        </el-form-item>
        <el-form-item :label="$store.state.pms.pageType[item.pageTypeCode] + '模板:'">
          <el-button type="primary" @click="clickAdd(item)" round>关联</el-button><span> 拖动修改模板顺序</span>
          <draggable v-model="item.templates" chosenClass="chosen" forceFallback="true" group="people" animation="1000" @end="draggEnd($event, item.templates, i)">
            <transition-group style="display: flex;flex-direction: row;flex-wrap:wrap;">
              <div v-for="(tem, index) in item.templates" :key='tem.id'
                style="width:170px;border:1px solid #000;margin:5px 5px 0 0;display:flex;flex-direction: column;justify-content: space-between;">
                <div class="imgBox">
                  <!-- {{ tem }} -->
                  <div class="img">
                    <el-image style="width:100%;height:100%;" :preview-src-list="tem.templates[0] ? [tem.templates[0].templateThumbnail] : []"
                      :src="tem.templates[0] ? [tem.templates[0].templateThumbnail] : []" fit="fill">
                    </el-image>
                  </div>
                  <!-- <div class="img" v-if="tem.propertyId!==2">
                    <el-image style="width:100%;height:100%;" :preview-src-list="tem.templateThumbnailList" :src="tem.templateThumbnailList[1]" fit="fill">
                    </el-image>
                  </div> -->
                </div>
                <p @click="deleteTemplates(item, index)" style="text-align:center;border-top:1px solid #000">删除</p>
              </div>
            </transition-group>
          </draggable>
        </el-form-item>
      </el-form>
      <div class="form-btn" style="margin: 20px 0">
        <!-- <el-button round @click="this.$router.go(-1)">上一步</el-button> -->
        <el-button round type="primary" @click="create" v-preventReClick>创建</el-button>
      </div>
    </div>
    <!-- 关联模板 -->
    <el-dialog :close-on-click-modal="false" title="关联模板" :visible.sync="addFormatDialog" width="75%" @close="$refs.formatList.clearSelection()">
      <el-form :inline="true" :model="searchTemplateVo" class="demo-form-inline">
        <el-form-item label="设计人员:">
          <el-input v-model="searchTemplateVo.createdName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="模板名称:">
          <el-input v-model="searchTemplateVo.groupName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="模板主题:">
          <el-select clearable v-model="searchTemplateVo.templateThemeId" placeholder="">
            <el-option v-for="item in sampleList" :key="item.id" :label="item.themeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期:">
          <el-date-picker v-model="value1" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="模板性质:">
          <el-select clearable v-model="searchTemplateVo.propertyId" placeholder="">
            <el-option v-for="item in FormatPropertyList" :key="item.id" :label="item.propertyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页面类型:">
          <span>{{ $store.state.pms.pageType[searchTemplateVo.pageTypeCode] }}</span>
        </el-form-item>
        <el-form-item label="宽高:">
          <span>{{ searchTemplateVo.templateSize }}</span>
        </el-form-item>
        <el-form-item label="照片数量:">
          <el-input v-model="searchTemplateVo.imageCout" placeholder=""></el-input>
        </el-form-item>
        <div style="float:right;margin-right:20px">
          <el-button @click="searchFormatList()" round>查询</el-button>
          <el-button type="primary" @click="addFormat()" round v-preventReClick>关联</el-button>
        </div>
      </el-form>
      <el-table :data="formatList" ref="formatList" @selection-change="handleFormatSelectionChange" style="width: 100%" row-key="id">
        <el-table-column type="selection" width="55" reserve-selection="true"></el-table-column>
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column label="模板页缩略图">
          <template slot-scope="scope">
            <div class="imgBox">
              <div class="img">
                <el-image style="width:100%;height:100%;" :preview-src-list="scope.row.templates[0] ? [scope.row.templates[0].templateThumbnail] : []"
                  :src="scope.row.templates[0] ? scope.row.templates[0].templateThumbnail : []" fit="fill">
                </el-image>
              </div>
              <!-- 原始链接: scope.row.templateThumbnailList -->
              <!-- 修改后链接: scope.row.templates[0].templateThumbnail -->
              <!-- <div class="img" v-if="scope.row.propertyId!==2">
                <el-image style="width:100%;height:100%;" :preview-src-list="scope.row.templateThumbnailList" :src="scope.row.templateThumbnailList[1]"
                  fit="fill"></el-image>
              </div> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="typeName" label="页面类型">
          <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
        </el-table-column>
        <el-table-column prop="propertyName" label="性质">
          <template slot-scope="scope"> {{ propertyObj[scope.row.propertyId] }} </template>
        </el-table-column>
        <el-table-column prop="imageCount" label="照片数量"></el-table-column>
        <el-table-column prop="templateSize" label="宽高"></el-table-column>
        <el-table-column prop="createdName" label="设计人员"></el-table-column>
        <el-table-column prop="themeName" label="主题"></el-table-column>
        <el-table-column prop="createdTime" label="创建日期"></el-table-column>
      </el-table>
      <v-pagination class="v-pagination" @changePage='changeFormatPage' :queryInfo='queryInfo'></v-pagination>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import draggable from 'vuedraggable'
import { composeGroupDetail, propertyGetPropertyList, groupRelate, pageNameListById, sampleListNoPaging, templateGroupGetTemplateGroupList } from '@/api/pms'
export default {
  name: 'add-hemorrhage',
  components: {
    draggable, VPagination
  },
  data () {
    return {
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 50
      },
      formatList: [],
      value1: [],
      addFormatDialog: false,
      searchTemplateVo: {
        createdName: '',
        groupName: '',
        auditStatus: 'AUDITED',
        createTimeBegin: '',
        createTimeEnd: '',
        imageCout: '',
        page: 1,
        pageTypeId: '',
        propertyId: '',
        templateSize: '',
        templateThemeId: ''
      },
      sizeGroupMsg: {
        sizeList: []
      },
      imgList: {
        cover: [],
        page: []
      },
      sampleList: [],
      FormatPropertyList: [],
      allFormatPropertyList: [],
      propertyObj: {},
      pageList: [],
      selectFormatList: [],
      textPageNum: 0,
      drag: false,
      dragIndex: '',
      enterIndex: '',
      // 存储交换数组
      dataList: []
    }
  },
  created () {
    // this.getPageMsg()
    this.getcomposeSizeGroupMsg()
    this.getFormatPropertyList()
    this.getFormatSampleList()
  },
  watch: {
    value1 (val) {
      this.searchTemplateVo.createTimeBegin = val === null ? '' : val[0]
      this.searchTemplateVo.createTimeEnd = val === null ? '' : val[1]
    }
  },
  methods: {
    // 拖拽结束
    draggEnd ({ oldIndex, newIndex }, data, index) {
      console.log(' this.sizeGroupMsg.sizeList', this.sizeGroupMsg.sizeList[index])
      // console.log('sizeGroupMsg.sizeList', this.sizeGroupMsg.sizeList)
      // this.dataList = data.map(a => { return a })
      // console.log('this.dataListOld', this.dataList)
      // console.log('oldIndex', oldIndex)
      // console.log('newIndex', newIndex)
      // const item = this.dataList[oldIndex + 1] // 拖拽的对象
      // this.dataList.splice(oldIndex, 1) // 删除原来位置的数据
      // console.log('this.dataListDelete', this.dataList)
      // console.log('item', item)
      // // 把拖拽的对象放到新的位置
      // this.dataList.splice(newIndex, 0, item)
      // console.log('this.dataListNew', this.dataList)
      // this.sizeGroupMsg.sizeList[index].templates = this.dataList
      // console.log('------新数据------', this.sizeGroupMsg.sizeList[index].templates)
      this.$forceUpdate()
    },
    deleteTemplates (item, index) {
      item.templates.splice(index, 1)
      this.$forceUpdate()
    },
    create () {
      let groupTemplateXrefVo = {
        groupId: JSON.parse(this.$route.query.detail).id,
        propertyIds: [],
        templateXrefVos: [],
        textPageNum: 0
      }
      console.log(this.sizeGroupMsg)
      this.sizeGroupMsg.sizeList.forEach(size => {
        size.pageMsg.templateProperty.forEach(tpro => {
          this.allFormatPropertyList.forEach(pro => {
            if (tpro === pro.propertyName) {
              groupTemplateXrefVo.propertyIds.push(pro.id)
            }
          })
        })
        let obj = {
          pageTypeCode: size.pageTypeCode,
          templateGroups: []
        }
        size.templates.forEach((tem, index) => {
          groupTemplateXrefVo.propertyIds.push(tem.propertyId)
          obj.templateGroups.push({
            sorting: index + 1,
            templateGroupId: tem.id
          })
        })
        groupTemplateXrefVo.templateXrefVos.push(obj)
      })
      let TEXTNUM = 0
      let SINGLENUM = 0
      groupTemplateXrefVo.templateXrefVos.forEach(k => {
        if (k.pageTypeCode === 'TEXT') {
          TEXTNUM = k.templateGroups.length
        }
        if (k.pageTypeCode === 'SINGLE') {
          SINGLENUM = k.templateGroups.length
        }
        groupTemplateXrefVo.textPageNum = TEXTNUM + SINGLENUM
      })
      groupTemplateXrefVo.propertyIds = Array.from(new Set(groupTemplateXrefVo.propertyIds))
      groupRelate(groupTemplateXrefVo).then(res => {
        if (res.data.success) {
          this.$message.success('创建成功')
          this.$router.push('/templateGroupList')
        }
      })
    },
    // 点击关联
    clickAdd (item) {
      console.log('groupVos', item)
      this.itemGroup = item.templates
      // this.FormatPropertyList = []
      // item.spuPageName.templateProperty.split(',').forEach(val => {
      //   this.FormatPropertyList.push(...this.allFormatPropertyList.filter(item => {
      //     return val === item.propertyName
      //   }))
      // })
      this.searchTemplateVo.pageTypeId = item.spuPageName.pageTypeId
      this.searchTemplateVo.pageTypeCode = item.pageTypeCode
      this.searchTemplateVo.templateSize = item.sizeWidth + 'x' + item.sizeHeight + 'mm'
      this.queryInfo.pageNum = 1
      this.addFormatDialog = true
      this.searchFormatList()
    },
    // 获取模板性质
    getFormatPropertyList () {
      propertyGetPropertyList().then(res => {
        if (res.data.success) {
          this.propertyObj = res.data.data.reduce((obj, item) => {
            obj[item.id] = item.propertyName
            return obj
          }, {})
          this.allFormatPropertyList = res.data.data
        }
      })
    },
    // 关联模板
    addFormat () {
      if (!this.selectFormatList) return
      this.sizeGroupMsg.sizeList.forEach(item => {
        if (item.pageTypeCode === this.searchTemplateVo.pageTypeCode) {
          item.templates = JSON.parse(JSON.stringify(this.selectFormatList))
        }
        // if (item.pageTypeCode === this.searchTemplateVo.pageTypeCode) {
        //   this.selectFormatList.forEach(tem => {
        //     let repetition = true
        //     item.templates.forEach(val => {
        //       if (val.id === tem.id) {
        //         repetition = false
        //       }
        //     })
        //     if (repetition) {
        //       item.templates.push(tem)
        //     }
        //   })
        // }
      })
      console.log('this.sizeGroupMsg.sizeList', this.sizeGroupMsg.sizeList)
      this.$refs.formatList.clearSelection()
      this.addFormatDialog = false
    },
    // 获取模板主题
    getFormatSampleList () {
      sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.sampleList = res.data.data
        }
      })
    },
    // 获取模板列表
    searchFormatList () {
      this.formatList = []
      templateGroupGetTemplateGroupList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchTemplateVo: this.searchTemplateVo }).then(res => {
        if (res.data.success) {
          let obj = res.data.data.records
          console.log('objobj', obj)
          obj.forEach(item => {
            if (item.propertyId === 2) {
              item.templateThumbnailList = item.templates.length > 0 ? [item.templates[0]?.templateThumbnail] : []
            } else {
              item.templateThumbnailList = item.templates.reduce((list, temp) => {
                list[temp?.templatePosition] = temp?.templateThumbnail || ''
                return list
              }, [])
            }
          })
          // 新加的
          // this.dataList = obj
          console.log('初始化this.dataList', this.dataList)
          this.formatList = obj
          this.queryInfo.total = res.data.data.total
          this.itemGroup.forEach(res => {
            this.formatList.forEach(a => {
              // console.log('aaaaa', res.id, a.id)
              if (res.id == a.id) {
                // console.log('aaaaa', a)
                this.$refs.formatList.toggleRowSelection(a)
              }
            })
          })
        }
      })
    },
    // 获取绑定的尺寸组详细信息
    getcomposeSizeGroupMsg () {
      composeGroupDetail(JSON.parse(this.$route.query.detail).composeSizeGroupId).then(res => {
        if (res.data.success) {
          this.sizeGroupMsg = res.data.data
          this.sizeGroupMsg.sizeList.forEach(item => {
            item.templates = []
            item.pageMsg = {
              templateProperty: []
            }
          })
          this.dataList = this.sizeGroupMsg.sizeList[0].templates
          console.log('dataList', this.dataList)
          this.getPageMsg()
        }
      })
    },
    // 获取页面名称
    getPageMsg () {
      pageNameListById(JSON.parse(this.$route.query.detail).composeSizeGroupId).then(res => {
        if (res.data.success) {
          this.pageList = res.data.data
        }
      })
    },
    handleFormatSelectionChange (val) {
      this.selectFormatList = val
    },
    changeFormatPage (val) {
      this.queryInfo = val
      this.searchFormatList()
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.add-hemorrhage {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: 110px;
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }

  .link {
    width: 30px;
    height: 30px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;

    i {
      font-size: 20px;
      color: #999;
    }
  }

  .active-link {
    background: #1473e6;
    border: 1px solid #1473e6;

    i {
      color: #fff;
    }
  }
}

.imgBox {
  width: 100%;
  display: flex;
  justify-content: space-around;

  .img {
    flex: 1;
  }
}
</style>
